// --------------------------------------------------------
// SCREEN_NAME - ScreenName
// --------------------------------------------------------

// --------------------------------------------------------
import React, { useCallback, useEffect, useState } from "react";
import ContainerWithSidebar from "../../../components/UI/containerWithSidebar/ContainerWithSidebar";
import MarkConsultButton from "../../../components/MarkConsultButton/MarkConsultButton";
import { GeneralContainer, H1, Text } from "../../../components/UI/generalLayout/Layout.styled";
import ScreenHeader from "../../../components/UI/screenHeader/ScreenHeader";
import {
  ButtonNotification,
  ContainerRow,
  HeaderInformation,
} from "./MyPeriodics.styled";
import { MdNotifications } from "react-icons/md";
import CardPeriodic from "../../../components/cardPeriodic/CardPeriodic";
import { CompanyService } from "../../../core/http/service/CompanyService";
import { useSelector } from "react-redux";
import Company from "../../../models/core/company/Company";
import CollaboratorInitialModalScheduling from "../../../components/collaboratorInitial/CollaboratorInitialSchedulingModal";
import { CircularProgress } from "@mui/material";
import useResponsiveInfo from "../../../hooks/useResponsiveInfo";
// --------------------------------------------------------
// SCREEN_NAME INTERFACE
// --------------------------------------------------------
/**
 * A component that renders a Screen.
 *
 * @param props Properties
 * @param props.route The route
 * @param props.navigation The navigator
 * @returns The component JSX.
 */

function MyPeriodics(): JSX.Element {
  // --------------------------------------------------------
  // SCREEN_NAME PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const [periodics, setPeriodics] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true)
  const [showModalScheduling, setShowModalScheduling] = useState(false)
  const currentCompany: Company = useSelector((state: any) => state.login.currentCompany)
  const userInfo: any = useSelector((state: any) => state.login.userInfo)
  const { isMobile } = useResponsiveInfo();

  const fetchPeriodics = useCallback(async () => {
    const service: CompanyService = new CompanyService();
    const periodicsResult: any[] = []
    try{
      const result: any = await service.getPeriodicsByCompanyPerson(currentCompany.id, userInfo.id)
      result.data.data.forEach((d: any) => {
        periodicsResult.push(d)
      })
      setPeriodics(periodicsResult)
    }catch(error: any){

    }
    setIsLoading(false)
  }, [currentCompany, userInfo])

  useEffect(() => {
    fetchPeriodics();
  }, [])

  return (
    <ContainerWithSidebar>
      <GeneralContainer>
        <div style={{ display: "flex", flexDirection: isMobile ? "column" : "row", justifyContent: "space-between", alignItems: isMobile ? "flex-start" : "center", gap: "16px", marginBottom: "24px", width: "100%" }}>
          <H1 style={{ color: "#0F172A", fontWeight: 700, fontSize: "22px", display: "flex", alignItems: "center", gap: "10px", margin: 0 }}>
            <span style={{ width: 4, height: 22, background: "#0A5190", borderRadius: 2, display: "inline-block" }}></span>
            <span>Meus Periódicos</span>
          </H1>
          <MarkConsultButton />
        </div>
        {isLoading ? (
          <div style={{ textAlign: 'center', width: '100%', height: 300, marginTop: 100 }}>
            <CircularProgress />
          </div>) : (
          <div>
            {periodics.length !== 0 && !isMobile && (<HeaderInformation>
              <Text bold={true}>Nome</Text>
              <Text
                bold={true}
                style={{
                  marginLeft: "5%",
                }}
              >
                Data prevista
              </Text>
              <Text bold={true}>Próximos exames</Text>
            </HeaderInformation>)}
            {periodics.map(p => {
              return <CardPeriodic title={p.nome} data={p} isCareLine={false} />
            })}
            {periodics.length === 0 && (<Text>Posto de Trabalho não possui Periódico Cadastrado. Entre em contato com sua liderança direta</Text>)}
          </div>
        )}
      </GeneralContainer>
    </ContainerWithSidebar>
  );
}

export default MyPeriodics;
